import ModalComponent from "../../../Components/ModalComponent";
import { Button, Col, Form, Input, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import { InputOTP } from "antd-input-otp";
import { showNotitfication } from "../../../utils/Utils";
import modalOtpAnimation from "../../../assets/otp-modal.json";
import Lottie from "lottie-react";
import { useTranslation } from "react-i18next";
import {
  toGetMyLoyaltyHistory,
  toGetMyWalletHistory,
  toGetProfil,
  toRedeemQitaf,
  toRedeemRajhi,
} from "../../../apis/actions/auth.actions";

interface OtpModalProps {
  onClose: () => void;
  open?: boolean;
  phone: string;
  type: "qitaf" | "rajhi";
  otp_token: string;
}

const OtpModal = ({ open, onClose, phone, type, otp_token }: OtpModalProps) => {
  const [form] = Form.useForm();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const { loading } = useSelector(
    (state: RootState) => state.login.redeemQitaf
  );
  const { loadingRajhi } = useSelector(
    (state: RootState) => state.login.redeemRajhi
  );
  const handleVerifyOtp = async () => {
    try {
      await form.validateFields(); // await validation

      const otp = form.getFieldValue("otp");
      const amount = form.getFieldValue("amount");

      if (
        !otp ||
        otp.length !== 4 ||
        otp.includes(undefined) ||
        otp.includes("")
      ) {
        return form.setFields([
          {
            name: "otp",
            errors: [t("otp.warning") || "Please enter a valid OTP"],
          },
        ]);
      }

      if (type == "qitaf") {
        const success = (await dispatch(
          toRedeemQitaf({
            otp: parseFloat(`${otp[0]}${otp[1]}${otp[2]}${otp[3]}`),
            phone: phone,
            amount: parseFloat(amount),
          })
        )) as any;

        const verifyOtp = success?.payload?.data?.result;

        if (verifyOtp?.code === 200) {
          form.resetFields();
          onClose();
          dispatch(toGetMyLoyaltyHistory());
          dispatch(toGetMyWalletHistory());
          dispatch(toGetProfil(i18n.language));
          showNotitfication(verifyOtp?.message, "success");
        } else {
          switch (verifyOtp?.message?.code) {
            case 1007:
            case 1015:
              showNotitfication(
                i18n.language === "en"
                  ? "The entered OTP is incorrect"
                  : "الرمز المدخل غير صحيح",
                "error",
                true
              );
              break;

            case 2007:
              showNotitfication(
                i18n.language === "en"
                  ? "Maximum Incorrect OTP Attempts Exceeded"
                  : "تم تجاوز الحد الأعلى لمحاولات استخدام رمز غير صحيح",
                "error",
                true
              );
              break;

            case 1030:
              showNotitfication(
                i18n.language === "en"
                  ? "OTP is expired and a new OTP is sent to the customer"
                  : "انتهت صلاحية الرمز المرسل. سوف يتم إرسال رمز جديد",
                "error",
                true
              );
              break;

            case 1014:
              showNotitfication(
                i18n.language === "en"
                  ? "Qitaf points balance is not enough to complete the redemption"
                  : "لا يوجد رصيد قطاف كاف لإتمام العملية.",
                "error",
                true
              );
              break;

            case 1012:
              showNotitfication(
                i18n.language === "en"
                  ? "Monthly redemption limit is exceeded"
                  : "تم الوصول للحد الأعلى الشهري للاستبدال.",
                "error",
                true
              );
              break;

            default:
              showNotitfication(
                i18n.language === "en" ? "Something went wrong" : "حدث خطأ ما",
                "error",
                true
              );
              break;
          }
        }
      } else {
        const success = (await dispatch(
          toRedeemRajhi({
            OTPValue: `${otp[0]}${otp[1]}${otp[2]}${otp[3]}`,
            amount: amount,
            OTPToken: otp_token,
            language: i18n.language,
          })
        )) as any;

        const verifyOtp = success?.payload?.data?.result;

        if (verifyOtp?.code === 200) {
          form.resetFields();
          onClose();
          dispatch(toGetMyLoyaltyHistory());
          dispatch(toGetMyWalletHistory());
          dispatch(toGetProfil(i18n.language));
          showNotitfication(verifyOtp?.message, "success");
        } else {
          // Error Handling
          switch (verifyOtp?.message?.code) {
            case 301:
              showNotitfication(
                i18n.language === "en"
                  ? "Invalid OTP"
                  : "الرمز المدخل غير صحيح",
                "error",
                true
              );
              break;

            case 303:
              showNotitfication(
                i18n.language === "en"
                  ? "OTP is expired"
                  : "انتهت صلاحية الرمز المرسل",
                "error",
                true
              );
              break;

            case 204:
              showNotitfication(
                i18n.language === "en"
                  ? "This member balance is insufficient for redemptions"
                  : "لا يوجد رصيد كاف لإتمام العملية. الرجاء إدخال قيمة مناسبة",
                "error",
                true
              );
              break;

            default:
              showNotitfication(
                i18n.language === "en" ? "Something went wrong" : "حدث خطأ ما",
                "error",
                true
              );
              break;
          }
        }
      }
    } catch (error) {
      // Validation failed, so just return without proceeding
      return;
    }
  };

  const handleCloseModal = () => {
    form.resetFields();
    onClose();
  };

  return (
    <>
      <ModalComponent
        width={500}
        title=""
        open={open}
        onClose={handleCloseModal}
        closeOnOutsideClick={true}
        destroyOnClose={true}
        canvasBackdrop
      >
        <div className="otp-modal-content ac--font-expo">
          <div className="otp-modal-image-text ac--font-expo">
            <Lottie
              style={{ width: "60%" }}
              animationData={modalOtpAnimation}
              loop={true}
            />
            <h3>{t("otp.code")}</h3>
            <span> {t("otp.text")}</span>
          </div>

          <div className="otp-modal-input ac--font-expo">
            <Form form={form} onFinish={handleVerifyOtp}>
              <Row>
                <Col span={2}></Col>
                <Col
                  span={20}
                  style={{ direction: i18n.language === "ar" ? "ltr" : "ltr" }}
                >
                  <Form.Item
                    name="otp"
                    rules={[{ required: true, message: t("otp.warning") }]}
                  >
                    <InputOTP autoFocus inputMode="tel" length={4} />
                  </Form.Item>
                </Col>
              </Row>
              <div
                style={{ marginTop: "2rem" }}
                className="otp-modal-image-text"
              >
                <h6> {t("result.amount")}</h6>
              </div>
              <Row>
                <Col span={2}></Col>
                <Col span={20}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    {i18n.language !== "ar" && (
                      <span
                        className="icon-saudi_riyal"
                        style={{ fontSize: "25px" }}
                      />
                    )}
                    <Form.Item
                      name="amount"
                      rules={[
                        { required: true, message: t("otp.warning.amount") },
                        {
                          validator: (_, value) => {
                            if (
                              value &&
                              (value.includes("-") || value.includes(","))
                            ) {
                              return Promise.reject(
                                i18n.language === "ar"
                                  ? "الرجاء إدخال ارقام موجبة"
                                  : "Please enter positive number!"
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Input
                        placeholder={t("result.amount")}
                        type="number"
                        onKeyDown={(e) => {
                          if (["-", ".", ",", "e", "E"].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Form.Item>
                    {i18n.language === "ar" && (
                      <span
                        className="icon-saudi_riyal"
                        style={{ fontSize: "25px" }}
                      />
                    )}
                  </div>
                </Col>
              </Row>
              <div className="otp-modal-footer">
                <div>
                  <Button
                    className="text-md ac--btn-edit-save"
                    title="تحقق"
                    htmlType="submit"
                    disabled={type == "qitaf" ? loading : loadingRajhi}
                  >
                    {t("btn.redeem_btn")}
                  </Button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </ModalComponent>
    </>
  );
};

export default OtpModal;
